(function(){
  'use strict';

  angular.module('eclipseApp.core').directive('orderSummaryTotal', function(){
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'modules/checkout/views/order-summary-total-directive.html'
    };
  });
})();
